import React from 'react'
import SchoolIcon from '@mui/icons-material/School'

import AdminMediaModal from './AdminMediaModal'
import { AdminCourseModalStyle } from '../styles'
import { deleteCourse, updateCourse } from '../../reducers/coursesReducer'

const config = {
    Icon: SchoolIcon,
    style: AdminCourseModalStyle,
    subKey: 'sub_courses',
    idPrefix: 'course',
    formLabel: 'Course details',
    rowsNoun: 'lessons',
    rowsHeading: 'Lessons',
    rowLabel: 'Lesson',
    update: updateCourse,
    remove: deleteCourse,
}

const AdminCourseModal = (props) => <AdminMediaModal config={config} {...props} />

export default AdminCourseModal
